export const BackofficeTermsPolicies = () => {
  return <div>terms and policies</div>;
};//TODO Terms & Policies must be a dyanmically configurable WYSIWIG. We may be changing our Terms and Policy from time to time. 
